import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { AppProvider } from "@shopify/polaris";
import AppFrame from "./components/AppFrame";


function App() {
  return (
      <div className="App">
        <BrowserRouter>
          <AppProvider
            i18n={{
              Polaris: {
                Avatar: {
                  label: "Avatar",
                  labelWithInitials: "Avatar with initials {initials}",
                },
                ContextualSaveBar: {
                  save: "Save",
                  discard: "Discard",
                },
                TextField: {
                  characterCount: "{count} characters",
                },
                TopBar: {
                  toggleMenuLabel: "Toggle menu",

                  SearchField: {
                    clearButtonLabel: "Clear",
                    search: "Search",
                  },
                },
                Modal: {
                  iFrameTitle: "body markup",
                },
                Frame: {
                  skipToContent: "Skip to content",
                  navigationLabel: "Navigation",
                  Navigation: {
                    closeMobileNavigationLabel: "Close navigation",
                  },
                },
              },
            }}
          >
            <AppFrame />
          </AppProvider>
        </BrowserRouter>
      </div>
  );
}

export default App;